/**
 * Built-in courses as plain data. This package depends on nothing so the
 * simulation's tests can load the gym without a dependency cycle; the sim's
 * validateCourse() checks the shape on load.
 *
 * The gym and Lache Practice are untimed practice courses. The timed courses (course version 2,
 * with a warm-up area, a start line, and a finish line) are listed in play
 * order in `timedCourseNames`: the tournament (qualifier, semi-final, final),
 * then the three bonus stages, each built around one characteristic (the
 * sprint is dry and flat, Sprint 2 extends its dense vault/slide rhythms, the descent goes down,
 * the ascent climbs), then the wall stages of
 * 2026-09-25 (the ramparts climb walls by their ledges, the rooftops leap gaps to higher roofs, the
 * gauntlet runs every move in one line with the salmon ladder in the middle), then Rush's
 * compact vaults, double pipes, water jump, and linked laches (2026-10-08).
 */

import ascentJson from "./ascent.json" with { type: "json" };
import descentJson from "./descent.json" with { type: "json" };
import finalJson from "./final.json" with { type: "json" };
import gauntletJson from "./gauntlet.json" with { type: "json" };
import gymJson from "./gym.json" with { type: "json" };
import lachePracticeJson from "./lache-practice.json" with { type: "json" };
import qualifierJson from "./qualifier.json" with { type: "json" };
import rampartsJson from "./ramparts.json" with { type: "json" };
import rooftopsJson from "./rooftops.json" with { type: "json" };
import rushJson from "./rush.json" with { type: "json" };
import semifinalJson from "./semifinal.json" with { type: "json" };
import sprintJson from "./sprint.json" with { type: "json" };
import sprint2Json from "./sprint2.json" with { type: "json" };

export { courseRevision } from "./revisions";

export const gym: unknown = gymJson;

/** Timed courses in play order: the course select lists them this way and "next course" follows it. */
export const timedCourseNames: string[] = [
  "qualifier",
  "semifinal",
  "final",
  "sprint",
  "sprint2",
  "descent",
  "ascent",
  "ramparts",
  "rooftops",
  "gauntlet",
  "rush",
];

export const courses: Record<string, unknown> = {
  gym,
  "lache-practice": lachePracticeJson,
  qualifier: qualifierJson,
  semifinal: semifinalJson,
  final: finalJson,
  sprint: sprintJson,
  sprint2: sprint2Json,
  descent: descentJson,
  ascent: ascentJson,
  ramparts: rampartsJson,
  rooftops: rooftopsJson,
  gauntlet: gauntletJson,
  rush: rushJson,
};

export function getCourseData(name: string): unknown {
  const c = courses[name];
  if (!c) throw new Error(`unknown course "${name}"`);
  return c;
}

export const courseNames: string[] = Object.keys(courses);
